"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MarkerIcon;

var _react = _interopRequireDefault(require("react"));

function MarkerIcon() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "12px",
    height: "17px",
    viewBox: "0 0 12 17",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": true
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "pages",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "componentes-V2",
    transform: "translate(-1095.000000, -1496.000000)",
    fill: "#EE3840",
    fillRule: "nonzero"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1101,1512.80869 C1100.42547,1512.80869 1099.90353,1512.51592 1099.60379,1512.02552 C1097.50357,1508.58933 1095,1504.06067 1095,1501.99996 C1095,1498.69157 1097.69157,1496 1101,1496 C1104.30843,1496 1107,1498.69157 1107,1501.99996 C1107,1504.06067 1104.49647,1508.58933 1102.39621,1512.02552 C1102.09647,1512.51592 1101.57457,1512.80869 1101,1512.80869 Z M1098.58834,1501.58799 C1098.58834,1502.91781 1099.67022,1503.99961 1101,1503.99961 C1102.32978,1503.99961 1103.41166,1502.91777 1103.41166,1501.58799 C1103.41166,1500.25826 1102.32978,1499.17642 1101,1499.17642 C1099.67022,1499.17642 1098.58834,1500.25826 1098.58834,1501.58799 Z",
    id: "Combined-Shape"
  }))));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/MapMarker/markerIcon.js
// module id = G190
// module chunks = 0